import { useMutation } from '@tanstack/react-query';
import useToast from '../useToast';
import { patchOrganizationActivation } from '@/services/api/requests/organization';

const useOrganizationActivation = (organizationId: string, action: 'deactivate' | 'reactivate') => {
  const toast = useToast();

  const { isPending, mutate, isSuccess } = useMutation({
    mutationFn: async () => {
      await patchOrganizationActivation(organizationId, action);
    },
    onSuccess: () => {
      toast({
        title: 'Success',
        description: `Organization has been successfully ${action}d.`,
        status: 'success',
      });

      setTimeout(() => {
        window.location.reload();
      }, 2000); // Delay to ensure the toast is shown before the reload
    },
    onError: (error) => {
      toast({
        title: 'Error',
        description: `Failed to ${action} organization: ${error.message}`,
        status: 'error',
      });
    },
  });

  return {
    isPending,
    mutate,
    isSuccess,
  };
};

export default useOrganizationActivation;
